
import DonCarlos from '../images/AF/president.png'
import DonCarlosBG from '../images/AF/DonCarlosBG.jpg'

import CasaCuba from '../images/AF/divine.png'
import CasaCubaBG from '../images/AF/CasaCubaBG.jpg'


import GranReserva from '../images/AF/canones.png'
import CanonesBG from '../images/AF/CanonesBG.jpg'


import Anjelo from '../images/AF/anjelo.png'
import AnjeloBG from '../images/AF/AnjeloBG.jpg'

import FF from '../images/AF/FF.png'
import FfBG from '../images/AF/FfBG.jpg'

import P20th from '../images/AF/20th.png'
import P20thBG from '../images/AF/20thBG.jpg'

// Don Carlos 
import President from '../images/AF/Don Carlos/president.png'
import PresidentOpen from '../images/AF/Don Carlos/PresidentBox.jpg'
import PresidentClosed from '../images/AF/Don Carlos/PresidentBoxClosed.jpg'

import No2 from '../images/AF/Don Carlos/No2.png'
import No2Open from '../images/AF/Don Carlos/NoOpen.jpg'
import No2Closed from '../images/AF/Don Carlos/NoClosed.jpg'

import shark from '../images/AF/Don Carlos/shark.png'
import sharkOpen from '../images/AF/Don Carlos/sharkOpen.jpg'
import sharkClosed from '../images/AF/Don Carlos/sharkClosed.jpg'

import robusto from '../images/AF/Don Carlos/robusto.png'
import robustoOpen from '../images/AF/Don Carlos/robustoOpen.jpg'
import robustoClosed from '../images/AF/Don Carlos/robustoClosed.jpg'

import No3 from '../images/AF/Don Carlos/No3.png'
import No3Open from '../images/AF/Don Carlos/No3Open.jpg'
import No3Closed from '../images/AF/Don Carlos/No3Closed.jpg'

import belicoso from '../images/AF/Don Carlos/belicoso.png'
import belicosoOpen from '../images/AF/Don Carlos/belicosoOpen.jpg'
import belicosoClosed from '../images/AF/Don Carlos/belicosoClosed.jpg'


//Casa Cuba
import divine from '../images/AF/Casa Cuba/divine.png'
import DivineOpen from '../images/AF/Casa Cuba/DivineOpen.jpg'
import DivineClosed from '../images/AF/Casa Cuba/DivineClosed.jpeg'

import sies from '../images/AF/Casa Cuba/sies.png'
import siesOpen from '../images/AF/Casa Cuba/siesOpen.jpg'
import siesClosed from '../images/AF/Casa Cuba/siesClosed.jpg'

import tres from '../images/AF/Casa Cuba/sies.png'
import tresOpen from '../images/AF/Casa Cuba/tresOpen.jpg'
import tresClosed from '../images/AF/Casa Cuba/tresClosed.jpg'

import cinco from '../images/AF/Casa Cuba/cinco.png'
import cincoOpen from '../images/AF/Casa Cuba/cincoOpen.jpg'
import cincoClosed from '../images/AF/Casa Cuba/cincoClosed.jpg'

import quatro from '../images/AF/Casa Cuba/quatro.png'
import quatroOpen from '../images/AF/Casa Cuba/quatroOpen.jpg'
import quatroClosed from '../images/AF/Casa Cuba/quatroClosed.jpg'


//Gran Reeserva
import canones from '../images/AF/GR/canones.png'
import canonesOpen from '../images/AF/GR/canonesOpen.jpg'
import canonesClosed from '../images/AF/GR/canonesClosed.jpg'

import churchill from '../images/AF/GR/churchill.png'
import churchillOpen from '../images/AF/GR/churchillOpen.jpg'
import churchillClosed from '../images/AF/GR/churchillClosed.jpg'

import No1 from '../images/AF/GR/No1.png'
import No1Open from '../images/AF/GR/No1Open.jpg'
import No1Closed from '../images/AF/GR/No1Closed.jpg'

import imperial from '../images/AF/GR/imperial.png'
import imperialOpen from '../images/AF/GR/imperialOpen.jpg'
import imperialClosed from '../images/AF/GR/imperialClosed.jpg'

import spanish from '../images/AF/GR/spanish.png'
import spanishOpen from '../images/AF/GR/spanishOpen.jpg'
import spanishClosed from '../images/AF/GR/spanishClosed.jpg'

import fina from '../images/AF/GR/fina.png'
import finaOpen from '../images/AF/GR/finaOpen.jpg'
import finaClosed from '../images/AF/GR/finaClosed.jpg'

// Anjelo
import No49 from '../images/AF/Anjelo/No49.png'
import No49Open from '../images/AF/Anjelo/anjeloOpen.jpg'
import No49Closed from '../images/AF/Anjelo/anjeloClosed.jpg'

import No48 from '../images/AF/Anjelo/No48.png'
import No48Open from '../images/AF/Anjelo/No48Open.jpg'
import No48Closed from '../images/AF/Anjelo/No48Closed.jpg'

import No888 from '../images/AF/Anjelo/No88.png'
import No888Open from '../images/AF/Anjelo/No888Open.jpg'
import No888Closed from '../images/AF/Anjelo/No888Closed.jpg'

import No60 from '../images/AF/Anjelo/No60.png'
import No60Open from '../images/AF/Anjelo/No60Open.jpg'
import No60Closed from '../images/AF/Anjelo/No60Closed.jpg'

import No55 from '../images/AF/Anjelo/No55.png'
import No55Open from '../images/AF/Anjelo/No55Open.jpg'
import No55Closed from '../images/AF/Anjelo/No55Closed.jpg'

import No77 from '../images/AF/Anjelo/No77.png'
import No77Open from '../images/AF/Anjelo/No77Open.jpg'
import No77Closed from '../images/AF/Anjelo/No77Closed.jpg'

//Fuente Fuente OpusX
import doubleCorona from '../images/AF/FF/doubleCorona.png'
import doubleCoronaOpen from '../images/AF/FF/doubleCoronaOpen.jpg'
import doubleCoronaClosed from '../images/AF/FF/doubleCoronaClosed.jpg'

import reserva from '../images/AF/FF/reserva.png'
import reservaOpen from '../images/AF/FF/rservaOpen.jpg'
import reservaCLosed from '../images/AF/FF/reservaClosed.jpg'

import PerfNo2 from '../images/AF/FF/PerfNo2.png'
import PerfNo2Open from '../images/AF/FF/PerfNo2Open.jpg'
import PerfNo2Closed from '../images/AF/FF/PerfNo2Closed.jpg'

import X from '../images/AF/FF/X.png'
import XOpen from '../images/AF/FF/XOpen.jpg'
import XClosed from '../images/AF/FF/XClosed.jpg'

import lancero from '../images/AF/FF/lancero.png'
import lanceroOpen from '../images/AF/FF/lanceroOpen.jpg'
import lanceroClosed from '../images/AF/FF/lanceroClosed.jpg'

import no77Shark from '../images/AF/FF/no77Shark.png'
import no77SharkOpen from '../images/AF/FF/no77SharkOpen.jpg'
import no77SharkClosed from '../images/AF/FF/no77SharkClosed.jpg'

//20th Anniversary

import gods from '../images/AF/20th/gods.png'
import godsOpen from '../images/AF/20th/godsOpen.jpg'
import godsClosed from '../images/AF/20th/godsClosed.jpg'

import power from '../images/AF/20th/power.png'
import powerOpen from '../images/AF/20th/powerOpen.png'
import powerClosed from '../images/AF/20th/powerClosed.jpg'

import father from '../images/AF/20th/father.png'
import fatherOpen from '../images/AF/20th/fatherOpen.png'
import fatherClosed from '../images/AF/20th/fatherClosed.jpg'

import belive from '../images/AF/20th/father.png'
import beliveOpen from '../images/AF/20th/beliveOpen.png'
import beliveClosed from '../images/AF/20th/beliveClosed.jpg'




export const ArturoFuenteData = [
    {
        id: 1,
        title: 'Don Carlos',
        subTitle: 'Наречени в чест на легендарния си създател и патриарх на семейство Фуенте Дон Карлос Фуенте, старши, пурите на Артуро Фуенте Дон Карлос са едни от най-добрите димове в света.',
        paragraphOne: `За да създаде този шедьовър, Карлос Фуенте, старши, смеси редки, реколта тютюни, които бяха ръчно подбрани и отлежали до 10 години. Тези пури са богати и ароматни, с безупречни опаковки от африкански Камерун, което ги прави толкова привлекателни за окото, колкото и за палитрата.`,
        imgUrl: DonCarlos,
        imagBg: DonCarlosBG,

        cigars: [
            {
                id: 1,
                title: 'Presidente',
                subtitle: '50 (20mm)',
                img: President,
                openBox: PresidentOpen,
                closedBox: PresidentClosed,
            },
            {
                id: 2,
                title: 'No 2',
                subtitle: '44/55 (17/22mm)',
                img: No2,
                openBox: No2Open,
                closedBox: No2Closed,
            },
            {
                id: 3,
                title: 'Eye of the shark',
                subtitle: '52  (21mm)',
                img: shark,
                openBox: sharkOpen,
                closedBox: sharkClosed,
            },
            {
                id: 4,
                title: 'Double Robusto',
                subtitle: '52 (21mm)',
                img: robusto,
                openBox: robustoOpen,
                closedBox: robustoClosed,
            },
            {
                id: 5,
                title: 'No 3',
                subtitle: '44  (17mm)',
                img: No3,
                openBox: No3Open,
                closedBox: No3Closed,
            },
            {
                id: 6,
                title: 'Belicoso',
                subtitle: '52 (21mm)',
                img: belicoso,
                openBox: belicosoOpen,
                closedBox: belicosoClosed,
            },


        ]
    },
    {
        id: 2,
        title: 'Casa Cuba',
        subTitle: 'Артуро Фуенте е роден на 18 ноември 1887 г. в Гуинес в провинция Ла Хабана, Куба. През 1906 г. Артуро се премества в Кий Уест, Флорида, красиво място, където кубинските имигранти, включително собствените му братя и сестри, вече са положили семената за процъфтяваща индустрия за пури. Тази индустрия се разраства на север, когато друг имигрант от Куба, Висенте Мартинес-Ибор, напуска Кий Уест и основава сега известния в момента град за пури, Ybor City, разположен в Тампа, Флорида.',

        imgUrl: CasaCuba,
        imagBg: CasaCubaBG,
        cigars: [
            {
                id: 1,
                title: 'Divine inspiration',
                subtitle: '47 (19mm)',
                img: divine,
                openBox: DivineOpen,
                closedBox: DivineClosed,
            },
            {
                id: 2,
                title: 'Doble Sies',
                subtitle: '52 (21mm)',
                img: sies,
                openBox: siesOpen,
                closedBox: siesClosed,
            },
            {
                id: 3,
                title: 'Doble Tres',
                subtitle: '44 (17mm)',
                img: tres,
                openBox: tresOpen,
                closedBox: tresClosed,
            },
            {
                id: 4,
                title: 'Doble Cinco',
                subtitle: '50 (20mm)',
                img: cinco,
                openBox: cincoOpen,
                closedBox: cincoClosed,
            },
            {
                id: 5,
                title: 'Doble Quatro',
                subtitle: '54 (21mm)',
                img: quatro,
                openBox: quatroOpen,
                closedBox: quatroClosed,
            }
        ]

    },
    {
        id: 3,
        title: 'Gran Reserva',
        subTitle: 'Всеки лист е избран от частен резерв, заделен изключително за направата на тези пури. Тези фини тютюни са международно признати за своето превъзходство. След това пурите на Arturo Fuente Gran Reserva® се навиват умело с африкански Камерун, Кънектикът Broadleaf, сянка на Кънектикът или еквадорски опаковани обвивки.',
        paragraphOne: `
        Без абсолютно никакви преки пътища, всяка стъпка от процеса на производство на пури се извършва изцяло на ръка, за да се осигури завършена пура без паралел. След това пурите се отлежават в испански кедрови трезори до върха на съвършенството, за да се създаде бленд от смесите, произвеждащи отлична „индивидуалистична“ пура в тежка категория, която да се брои сред най-добрите в света.        `,

        imgUrl: GranReserva,
        imagBg: CanonesBG,
        cigars: [
            {
                id: 1,
                title: 'Canones',
                subtitle: '52 (21mm)',
                img: canones,
                openBox: canonesOpen,
                closedBox: canonesClosed
            },
            {
                id: 2,
                title: 'Churchill',
                subtitle: '48 (19mm)',
                img: churchill,
                openBox: churchillOpen,
                closedBox: churchillClosed,
            },
            {
                id: 3,
                title: 'Selecction Privada No 1',
                subtitle: '44 (17mm)',
                img: No1,
                openBox: No1Open,
                closedBox: No1Closed,
            },
            {
                id: 4,
                title: 'Corona Imperial',
                subtitle: '46 (18mm)',
                img: imperial,
                openBox: imperialOpen,
                closedBox: imperialClosed,
            },
            {
                id: 5,
                title: 'Spanish Lonsdale',
                subtitle: '42 (17mm)',
                img: spanish,
                openBox: spanishOpen,
                closedBox: spanishClosed,
            },
            {
                id: 6,
                title: 'FLor Fina',
                subtitle: '47 (19mm)',
                img: fina,
                openBox: finaOpen,
                closedBox: finaClosed,
            },

        ]
    },
    {
        id: 4,
        title: 'Anjelo',
        subTitle: 'Богатите листа от обвивка на мадуро, отлежали в бъчви с коняк, правят пурата Arturo Fuente Añejo уникален дим. Въпреки че тази линия се отличава с няколко различни размера, тя е дом на една от най-известните фигури в света, No. 77 или Shark, както е известна.',
        paragraphOne: `
        Акулата е първата пула с торпедна форма, някога навита, която преминава от закръглена форма на парежо до квадратна преса. Тази пура Añejo е особено рядка.
        `,
        imgUrl: Anjelo,
        imagBg: AnjeloBG,
        cigars: [
            {
                id: 1,
                title: 'No 49',
                subtitle: '19 (19mm)',
                img: No49,
                openBox: No49Open,
                closedBox: No49Closed,
            },
            {
                id: 2,
                title: 'No 48',
                subtitle: '48 (19mm)',
                img: No48,
                openBox: No48Open,
                closedBox: No48Closed,
            },
            {
                id: 3,
                title: 'No 888',
                subtitle: '44 (17mm)',
                img: No888,
                openBox: No888Open,
                closedBox: No888Closed,
            },
            {
                id: 4,
                title: 'No 60',
                subtitle: '48 (19mm)',
                img: No60,
                openBox: No60Open,
                closedBox: No60Closed,
            },
            {
                id: 5,
                title: 'No 55',
                subtitle: '55 (22mm)',
                img: No55,
                openBox: No55Open,
                closedBox: No55Closed,
            },
            {
                id: 6,
                title: 'No 77 Shark',
                subtitle: '50/64 (20/25mm)',
                img: No77,
                openBox: No77Open,
                closedBox: No77Closed,
            }
        ]
    },
    {
        id: 5,
        title: 'Fuente Fuente Opus X',
        subTitle: 'Сгушен в богатата вулканична почва на Доминиканската република, се намира Шато де ла Фуенте, дом на най-изисканата пура на нашето време, желаният Fuente Fuente OpusX.',
        paragraphOne: `
        Богатите на минерали почви на Доминиканската република, считани някога за неподходящи за опаковане на тютюн, никога не са срещали експертизата и упоритостта на семейство Фуенте. Заедно те култивираха великолепен тютюн, който се превърна в основата на известния Fuente Fuente OpusX, първият доминикански пуро в историята.       
         `,
        paragraphTwo: `
         Днес Fuente Fuente OpusX се счита за върха на съвършенството на пурите и стандарт, по който се измерват всички пури. Уникалната комбинация от тютюни Fuente произвежда вкусове както гладки, така и смели, в хармония със сладката трайна пълнота на ексклузивния тютюн за обвивка Fuente Fuente OpusX. Безупречна конструкция, изискан вкус и век на майсторство и традиция.
         `,
        imgUrl: FF,
        imagBg: FfBG,
        cigars: [
            {
                id: 1,
                title: 'Double Corona',
                subtitle: '49 (19mm)',
                img: doubleCorona,
                openBox: doubleCoronaOpen,
                closedBox: doubleCoronaClosed,
            },
            {
                id: 2,
                title: `Reserva D'Chateau`,
                subtitle: '48 (19mm)',
                img: reserva,
                openBox: reservaOpen,
                closedBox: reservaCLosed,
            },
            {
                id: 3,
                title: 'Perfecxion No 2',
                subtitle: '52 (21mm)',
                img: PerfNo2,
                openBox: PerfNo2Open,
                closedBox: PerfNo2Closed,
            },
            {
                id: 4,
                title: 'Perfecxion X',
                subtitle: '48 (19mm)',
                img: X,
                openBox: XOpen,
                closedBox: XClosed,
            },
            {
                id: 5,
                title: 'Petit Lancero',
                subtitle: '39 (15mm)',
                img: lancero,
                openBox: lanceroOpen,
                closedBox: lanceroClosed,
            },
            {
                id: 6,
                title: 'Perfecxion No77 Shark',
                subtitle: '52 (21mm)',
                img: no77Shark,
                openBox: no77SharkOpen,
                closedBox: no77SharkClosed,
            }


        ]
    },
    {
        id: 6,
        title: '20th Anniversary',
        subTitle: 'Исках да продуцирам нещо, което си спомних. Исках да се върна в детството си. Исках да се върна към най-щастливите моменти от живота си. Исках дядо ми да се гордее с мен. Исках баща ми да се гордее с мен, а децата ми някой ден да се гордеят с мен. Това беше нещо, което трябваше да направя.',
        imgUrl: P20th,
        imagBg: P20thBG,
        cigars: [
            {
                id: 1,
                title: `God's whisper`,
                subtitle: '56 (22mm)',
                img: gods,
                openBox: godsOpen,
                closedBox: godsClosed,
            },
            {
                id: 2,
                title: `Power of the dream`,
                subtitle: '52 (21mm)',
                img: power,
                openBox: powerOpen,
                closedBox: powerClosed,
            },
            {
                id: 3,
                title: `Father & Son`,
                subtitle: '49 (19mm)',
                img: father,
                openBox: fatherOpen,
                closedBox: fatherClosed,
            },
            {
                id: 4,
                title: `Belive`,
                subtitle: '52 (21mm)',
                img: belive,
                openBox: beliveOpen,
                closedBox: beliveClosed,
            },

        ]
    }
]